import { action, observable, computed } from 'mobx';
import { canUseWindow } from '../domain/ssrTools';

export default class MessageService {
  private static _instance: MessageService;
  
  @observable
  private _closed: boolean;

  public static GetInstance() {
    if (this._instance == undefined) {
      this._instance = new MessageService();
    }

    return this._instance;
  }

  @computed
  public get isClosed() {
    return this._closed;
  }

  @action
  public closeMessage() {
    this._closed = true;
    this.save();
  }

  private save() {
    if (canUseWindow()) {
      localStorage.setItem('message', JSON.stringify(this._closed));
    }
  }

  private async initialize() {
    if (canUseWindow()) {
      const tempMsg = localStorage.getItem('message');
      tempMsg ? (this._closed = JSON.parse(tempMsg)) : (this._closed = false);
    }
  }

  private constructor() {
    this.initialize();
  }
}



// WEBPACK FOOTER //
// ./src/services/MessageService.ts